import { DrawOption } from '@/modules/ta/widget/widget.constants';
import { WebBorderStyle } from '@/modules/ta/widget/builder.constants';

export class DrawOptionItem {
  /**
   * @type {*}
   */
  value;

  /**
   * type {boolean}
   */
  overridden;

  /**
   * @type {Object}
   */
  metadata;

  constructor(model = {}) {
    this.value = model.value;
    this.overridden = model.overridden;
    this.metadata = model.metadata || {};
  }

  /**
   *
   * @param key
   */
  buildDrawOptionDefaultMetadata(key) {
    switch (key) {
      case DrawOption.SHOW_BACKGROUND:
        this.metadata = {
          color: this.metadata.color ?? null,
        };
        break;
      case DrawOption.SHOW_SHADOW:
        this.metadata = {
          // eslint-disable-next-line tap/no-raw-text-js
          color: this.metadata.color ?? null,
          x: this.metadata.x ?? 3,
          y: this.metadata.y ?? 3,
          blur: 5,
        };
        break;
      case DrawOption.SHOW_BORDERS:
        this.metadata = {
          // eslint-disable-next-line tap/no-raw-text-js
          color: this.metadata.color ?? null,
          size: this.metadata.size ?? 1,
          radius: this.metadata.radius ?? 10,
          style: this.metadata.style ?? WebBorderStyle.SOLID,
        };
        break;
      default:
        break;
    }
  }
}
